<template lang="pug">
  app-layout
    v-container.layout(fluid)
      v-layout(column wrap align-center justify-center)
        v-flex(mb-1 shrink)
          v-img.header-image(src="/static/img/groupgray.svg")
        v-flex(mb-4 shrink)
          h1.text-center Import your contacts
        v-flex(py-3 mb-6 shrink)
          v-layout(column wrap align-center justify-center)
            router-link(to="/contacts/import/process")
              v-btn(outlined color="primary") From my computer
            span.text-center File format must be CSV
</template>

<script>
export default {
  name: 'contact-import-menu',
};
</script>

<style lang="scss" scoped>
.layout{
  align-items: center;
  .header-image{
    width: 153px;
    height: 143px;
  }
}
</style>